import { LOCATION_CHANGE } from 'connected-react-router';

import { RECEIVE_ADD_ONS, RECEIVE_SOFT_BUNDLE } from './addon-actions';

const NULL_STATE = {};

const AddOnReducer = (state = NULL_STATE, action) => {
    Object.freeze(state);
    switch (action.type) {
        case LOCATION_CHANGE:
            return NULL_STATE;
        case RECEIVE_ADD_ONS:
            return Object.assign({}, state, { [action.sku]: action.addOns });
        case RECEIVE_SOFT_BUNDLE:
            return Object.assign({}, state, { [`${action.sku}_softbundles`]: action.softBundlesAddOns });
        default:
            return state;
    }
};

export default AddOnReducer;
